import React, {} from 'react';
import { Wordmark } from '../Wordmark/Wordmark.js';
const styles = {"page":"AuthLayout-module__page__38x3s","stage":"AuthLayout-module__stage__Uygq-","card":"AuthLayout-module__card__f-Vxk","topAction":"AuthLayout-module__topAction__kJB7q","heading":"AuthLayout-module__heading__X28BA","title":"AuthLayout-module__title__1We2A","description":"AuthLayout-module__description__k-TtB","content":"AuthLayout-module__content__zrsoR","footnote":"AuthLayout-module__footnote__ZtpiC"};
/**
 * The sign-in page layout (frames C1–D8; unnamed on the board): a centred 440 px card on desktop, no card on phone.
 * The card is a form that leaves validation to the page.
 */
export function AuthLayout({ wordmarkLabel, title, description, onSubmit, topAction, notice, footnote, children }) {
    function handleSubmit(event) {
        event.preventDefault();
        onSubmit();
    }
    return (React.createElement("div", { className: styles.page },
        React.createElement(Wordmark, { label: wordmarkLabel, size: "lg" }),
        React.createElement("main", { className: styles.stage },
            React.createElement("form", { className: styles.card, noValidate: true, onSubmit: handleSubmit },
                topAction !== undefined && React.createElement("div", { className: styles.topAction }, topAction),
                React.createElement("div", { className: styles.heading },
                    React.createElement("h1", { className: styles.title }, title),
                    React.createElement("p", { className: styles.description }, description)),
                notice,
                React.createElement("div", { className: styles.content }, children),
                footnote !== undefined && React.createElement("p", { className: styles.footnote }, footnote)))));
}
//# sourceMappingURL=AuthLayout.js.map